import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';

interface MarkdownViewerProps {
  url: string;
}

const MarkdownViewer = ({ url }: MarkdownViewerProps) => {
  const [markdown, setMarkdown] = useState('');

  useEffect(() => {
    fetch(url)
      .then((res) => res.text())
      .then((text) => setMarkdown(text))
      .catch((err) => console.error('Error loading markdown:', err));
  }, [url]); // Añade url como dependencia para que se vuelva a cargar cuando cambie

  return (
    <div style={{ padding: '1rem' }}>
      <ReactMarkdown>{markdown}</ReactMarkdown>
    </div>
  );
};

export default MarkdownViewer;